import { pick, serverMap } from '@/shared/lib/server-map'
import type { BookingStatus } from '@/shared/api'

const FALLBACK = 'var(--ink-3)'

/**
 * `BookingStatus` → CSS-токен цвета. Сервер отдаёт код статуса и готовую подпись (`statusLabel`),
 * палитра целиком на фронте. Ключ `string` и чтение через `pick` — по правилу незнакомого значения
 * (`model/server-drift.ts`).
 *
 * ⚠️ ИМЯ ТОКЕНА И ИМЯ СТАТУСА СОВПАДАТЬ НЕ ОБЯЗАНЫ, и разошлись они намеренно: `checked_in` красится
 * `--st-in`, `cancelled` — `--st-cancel` (так названо в `tokens.css`, это не опечатка). Токены —
 * палитра, их переименование стоит правки каждой темы; статусы — словарь домена, и он не наш.
 *
 * ⚠️ ПЕРЕЧНЯ «СТАТУС → ТОКЕН» В КОММЕНТАРИИ БЫТЬ НЕ ДОЛЖНО: словарь домена и палитра меняются
 * порознь, и такой перечень гниёт с первого же расхождения — `--st-in`/`--st-out` пережили
 * переименование статусов, которые ими красятся. Карта ниже читается глазами и не гниёт.
 */
const STATUS_TOKENS = serverMap({
  pending: 'var(--st-pending)',
  confirmed: 'var(--st-confirmed)',
  checked_in: 'var(--st-in)',
  checked_out: 'var(--st-out)',
  cancelled: 'var(--st-cancel)',
  no_show: 'var(--st-noshow)',
  /*
   * ⚠️ Блокировка — НЕ БРОНЬ, и цвет говорит об этом первым: холодная нейтраль, а не тёплая
   * `--st-out` («гость выехал»). Совпади они, закрытая на ремонт квартира читалась бы как
   * завершившееся проживание.
   */
  blocked: 'var(--st-blocked)',
})

export function statusToken(status: BookingStatus): string {
  return pick(STATUS_TOKENS, status, FALLBACK)
}

/**
 * Словарь ФИЛЬТРА списка броней. Одна копия на всё приложение: из неё собирается zod-схема адреса
 * (`app/router/search.ts`) и ею же сверяются пришедшие с сервера чипы (`features/bookings-filter`).
 *
 * ⚠️ Копия рукописная, и другого способа нет: zod и проверка на рантайме требуют ЗНАЧЕНИЙ, а
 * кодоген даёт только тип.
 */
export const bookingFilterStatuses = [
  'all',
  'pending',
  'confirmed',
  'checked_in',
  'checked_out',
  'cancelled',
  'no_show',
  'blocked',
] as const
